// @flow

import React from 'react'
import styled from 'styled-components'
import { Checkbox } from 'antd'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

const List = styled.ul`
  ${mediaMin.phone`
    margin: 0 -4px;
  `};
`
const ListItem = styled.li`
  display: inline-block;
  width: 100%;
  vertical-align: top;

  &:not(:first-of-type) {
    margin-top: ${spacing.medium__15}px;
  }

  ${mediaMin.phone`
    width: 33.333%;
    padding: 0 4px;
    &:not(:first-of-type) {
      margin-top: 0;
    }
    &:not(:nth-child(-n+3)) {
      margin-top: ${spacing.medium_2}px;
    }
  `};
`
const FullList = styled.ul``

const FullListItem = styled.li`
  &:not(:first-of-type) {
    margin-top: ${spacing.medium__15}px;
    ${mediaMin.phone`
      margin-top: ${spacing.medium_2}px;
    `};
  }
`
const Footer = styled.p`
  display: block;
  margin-top: ${spacing.small_2}px;
  font-size: ${fontSize.small_3}px;
  line-height: 1.363;
`

export type CheckboxType = {
  label: string,
  value?: ?number,
  desc?: ?string,
  checked?: ?boolean,
  additionalContent?: React$Element<*>,
}

export type PropTypes = {
  checkboxList: Array<CheckboxType>,
  onChange: (e: SyntheticInputEvent<*>, index: number) => void,
  widthType: string,
}

function getSelectedList(widthType) {
  switch (widthType) {
    case 'full':
      return FullList
    default:
      return List
  }
}
function getSelectedListItem(widthType) {
  switch (widthType) {
    case 'full':
      return FullListItem
    default:
      return ListItem
  }
}

export default class CheckboxList extends React.Component<*> {
  props: PropTypes

  render() {
    const { widthType, checkboxList } = this.props
    const SelectedList = getSelectedList(widthType)
    const SelectedListItem = getSelectedListItem(widthType)

    return (
      <SelectedList widthType={widthType}>
        {checkboxList.map((checkbox, index) => (
          <SelectedListItem key={index} widthType={this.props.widthType}>
            <Checkbox
              onChange={e => this.props.onChange(e, index)}
              value={checkbox.value}
              checked={checkbox.checked}
            >
              {checkbox.label}
              {checkbox.footer && <Footer>{checkbox.footer}</Footer>}
            </Checkbox>
            {checkbox.additionalContent}
          </SelectedListItem>
        ))}
      </SelectedList>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/CheckboxList/index.jsx